<app-v2-modal
  [title]="title"
  [subtitle]="subtitle"
  size="lg"
  (closeClick)="close()">
  <div slot="body" class="v2-expense-body">
    <app-form-input-repeater
      [field]="field"
      [control]="formGroup.controls[field.fieldUuid]"
      [hideExcept]="item">
    </app-form-input-repeater>
  </div>

  <div slot="footer" class="v2-expense-footer">
    <button type="button" class="v2-dlg-btn v2-dlg-btn--cancel" (click)="close()" i18n>Prekliči</button>
    <button type="button" class="v2-dlg-btn v2-dlg-btn--primary"
            [disabled]="isSubmitting || item?.invalid"
            (click)="save(false)" i18n>Shrani</button>
    @if (!isEditingExistingItem) {
      <button type="button" class="v2-dlg-btn v2-dlg-btn--primary"
              [disabled]="isSubmitting || item?.invalid"
              (click)="save(true)" i18n>Shrani in dodaj novo</button>
    }
  </div>
</app-v2-modal>
